'use client'

import React from 'react'
import { MissionBlock } from '@/payload-types'
import { Header } from '@/ui/components/Header'
import { Quote } from '@/ui/atoms/Quote'
import { Button } from '@/ui/atoms/Button'
import Link from 'next/link'

export const MissionBlockComponent: React.FC<MissionBlock> = ({
  label,
  title,
  description,
  quote,
  buttons,
}) => {
  return (
    <section>
      {/* Header Section */}
      <Header label={label} title={title} description={description} />

      {/* Quote Section */}
      {quote && typeof quote.author === 'object' && (
        <Quote
          text={quote.text}
          authorName={quote.author.name}
          authorTitle={quote.author.description || undefined}
          authorImage={typeof quote.author.image === 'object' ? quote.author.image : undefined}
          authorLink={quote.author.linkedin || undefined}
          className="mb-8"
        />
      )}

      {/* Buttons Section */}
      {buttons && buttons.length > 0 && (
        <div className="flex flex-wrap gap-4 justify-center">
          {buttons.map((button, index) => {
            const isAnchor = button.link.startsWith('#')

            const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
              if (isAnchor) {
                e.preventDefault()
                const targetId = button.link.substring(1)
                const targetElement = document.getElementById(targetId)

                if (targetElement) {
                  targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                  })
                }
              }
            }

            return (
              <Button key={index} asChild variant="primary">
                <Link href={button.link} onClick={handleClick}>
                  {button.label}
                </Link>
              </Button>
            )
          })}
        </div>
      )}
    </section>
  )
}
